import React from 'react';
import { Layout } from '@design-system/Layout/Layout';
import styled from 'styled-components';
import Instagram from '@design-system/Assets/Instagram';
import Twitter from '@design-system/Assets/Twitter';
import Mail from '@design-system/Assets/Mail';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

const Body = styled.div`
  display: flex;
  align-contne: center;
  align-items: center;
  margin-top: 10px;
  white-space: no-wrap;
  margin-left: 0;

  ${mediaQuery.desktop`
  display: flex;
  align-contne: center;
  align-items: center;
  margin-top: 10px;
  white-space: no-wrap;
  margin-left: 50px;

  `}
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
  color: #549a9a;
  margin-top: 10px;

  ${mediaQuery.desktop`
  font-weight: 600;
  font-size: 24px;
  color: #549A9A;

  `}
`;

const SubHeader = styled.div`
  font-weight: 500;
  font-size: 15px;
  color: #333333;
  margin-top: 10px;
  margin-left: 0;

  ${mediaQuery.desktop`
  font-weight: 600;
  font-size: 32px;
  color: #333333;
  margin-top: 30px;
  margin-left: 50px;
  `}
`;

const MidText = styled.div`
  font-weight: 500;
  font-size: 15px;
  color: #4f4f4f;
  margin-left: 0;

  ${mediaQuery.desktop`
  font-weight: 500;
  font-size: 18px;
  color: #4f4f4f;
  margin-left: 50px;

  `}
`;

const HelpText = styled.div`
  font-weight: 500;
  font-size: 15px;
  color: #549a9a;
  margin-left: 10px;

  ${mediaQuery.desktop`
  font-weight: 500;
  font-size: 18px;
  color: #549a9a;
  margin-left: 10px;

  `}
`;

const Help = () => {
  return (
    <Layout>
      <div className="main">
        <Header>Help</Header>

        <SubHeader>Contact Us</SubHeader>
        <MidText>We will get back to you as soon as possible</MidText>

        <Body>
          <Mail />
          <HelpText>Info@useakaani.com</HelpText>
        </Body>
        <Body>
          <Twitter />
          <HelpText>@useakaani</HelpText>
        </Body>
        <Body>
          <Instagram />
          <HelpText>@useakaani</HelpText>
        </Body>
      </div>
    </Layout>
  );
};

export default Help;
